const SOUND_URL = "/sounds/notification.wav";

let audio = null;
let unlocked = false;

const getAudio = () => {
  if (!audio) {
    audio = new Audio(SOUND_URL);
    audio.preload = "auto";
    audio.volume = 0.5;
  }
  return audio;
};

// "Разблокировка" аудио на первый жест пользователя:
// браузеры (autoplay policy) разрешают воспроизведение звука только после
// взаимодействия пользователя со страницей, поэтому на первый pointerdown/keydown
// беззвучно проигрываем и сразу останавливаем аудио — после этого
// последующие вызовы play() уже не блокируются
const unlock = () => {
  if (unlocked) return;

  const a = getAudio();
  a.muted = true;
  a.play()
    .then(() => {
      a.pause();
      a.currentTime = 0;
      a.muted = false;
      unlocked = true;
      ["pointerdown", "keydown"].forEach((event) =>
        window.removeEventListener(event, unlock, true)
      );
    })
    .catch(() => {
      // жеста ещё не было — попробуем на следующем событии
      a.muted = false;
    });
};

if (typeof window !== "undefined") {
  ["pointerdown", "keydown"].forEach((event) =>
    window.addEventListener(event, unlock, true)
  );
}

// Проигрывает звуковой сигнал уведомления
export const playNotificationSound = () => {
  try {
    const a = getAudio();
    a.currentTime = 0;

    const playPromise = a.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch((error) => {
        // NotAllowedError — пользователь ещё не взаимодействовал со страницей,
        // сигнал молча пропускаем (очередь устаревших звуков не накапливаем)
        if (error?.name !== "NotAllowedError") {
          console.warn("Не удалось воспроизвести звук уведомления:", error);
        }
      });
    }
  } catch (error) {
    // не ломаем поток обработки уведомлений из-за проблем со звуком
    console.warn("Не удалось воспроизвести звук уведомления:", error);
  }
};
